<div class="intro">
  <iframe width="100%" height="720" [src]="iframeSrc" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe>
</div>
